// Generated local binding projection. Do not edit.
import { productAllowed } from './product-policy';
export const productContractPin = "fff64dad4589c07b26821cb23a866aaec6f824e7786d719ca6e3122b3750895a";
export const productBindings: Readonly<Record<string, string>> = {
  "GaussianRenderMode.sorted": "view.render",
  "GaussianRenderMode.steady": "view.render",
  "GraphicsBackendPreference.auto": "view.render",
  "GraphicsBackendPreference.webgl2": "view.render",
  "GraphicsBackendPreference.webgpu": "view.render",
  "SelectionTool.brush": "selection.manual",
  "SelectionTool.color": "selection.color",
  "SelectionTool.fill": "selection.color",
  "SelectionTool.polygon": "selection.manual",
  "SelectionTool.rectangle": "selection.manual",
  "SelectionTool.single": "selection.manual",
  "SelectionTool.volume": "selection.manual",
  "ToolbarAction.capture": "view.capture",
  "ToolbarAction.save": "save.copy",
  "ToolbarAction.thumbnail": "view.remember",
  "ToolsMode.basic": "settings.general",
  "ToolsMode.pro": "processing.advanced",
  "TutorialTarget.actions": "selection.manual",
  "TutorialTarget.area": "selection.manual",
  "TutorialTarget.auto-color": "color.auto",
  "TutorialTarget.auto-rotate": "view.navigate",
  "TutorialTarget.brushes": "selection.manual",
  "TutorialTarget.capture": "view.capture",
  "TutorialTarget.cleanup-reset": "cleanup.edit",
  "TutorialTarget.color-reset": "color.basic",
  "TutorialTarget.color-select": "selection.color",
  "TutorialTarget.color-slider": "color.basic",
  "TutorialTarget.combine": "selection.manual",
  "TutorialTarget.coordinates": "transform.numeric",
  "TutorialTarget.current-view": "selection.advanced",
  "TutorialTarget.duplicate": "processing.advanced",
  "TutorialTarget.fill": "selection.color",
  "TutorialTarget.filter": "selection.volume",
  "TutorialTarget.floor": "alignment.auto",
  "TutorialTarget.gizmo": "transform.manual",
  "TutorialTarget.guides": "view.navigate",
  "TutorialTarget.histogram": "color.auto",
  "TutorialTarget.lens": "view.navigate",
  "TutorialTarget.modes": "processing.advanced",
  "TutorialTarget.navigation": "view.navigate",
  "TutorialTarget.open": "document.open",
  "TutorialTarget.options": "selection.manual",
  "TutorialTarget.pick-center": "alignment.manual",
  "TutorialTarget.pivot": "transform.numeric",
  "TutorialTarget.plane-align": "alignment.manual",
  "TutorialTarget.presets": "color.basic",
  "TutorialTarget.pro-color": "color.advanced",
  "TutorialTarget.range": "selection.advanced",
  "TutorialTarget.refine": "selection.advanced",
  "TutorialTarget.save": "save.copy",
  "TutorialTarget.scale-align": "alignment.manual",
  "TutorialTarget.scope": "settings.general",
  "TutorialTarget.selection-edits": "selection.manual",
  "TutorialTarget.selection-finish": "selection.manual",
  "TutorialTarget.settings": "settings.general",
  "TutorialTarget.single": "selection.manual",
  "TutorialTarget.snap-flips": "transform.manual",
  "TutorialTarget.thumbnail": "view.remember",
  "TutorialTarget.tools": "settings.general",
  "TutorialTarget.transform-mode": "transform.numeric",
  "TutorialTarget.transform-reset": "transform.manual",
  "TutorialTarget.transform-values": "transform.numeric",
  "TutorialTarget.undo-redo": "history.edit",
  "WorkerCommand.alignCenter": "alignment.manual",
  "WorkerCommand.alignFloor": "alignment.auto",
  "WorkerCommand.alignPlane": "alignment.manual",
  "WorkerCommand.alignScale": "alignment.manual",
  "WorkerCommand.applyOpacity": "color.advanced",
  "WorkerCommand.applyTransform": "transform.manual",
  "WorkerCommand.autoColor": "color.auto",
  "WorkerCommand.beginColor": "color.basic",
  "WorkerCommand.beginFilter": "selection.volume",
  "WorkerCommand.beginOpacity": "color.advanced",
  "WorkerCommand.beginSelection": "selection.manual",
  "WorkerCommand.beginTransaction": "internal.lifecycle",
  "WorkerCommand.beginTransform": "transform.manual",
  "WorkerCommand.brush": "selection.manual",
  "WorkerCommand.cancel": "internal.lifecycle",
  "WorkerCommand.cancelFilter": "selection.volume",
  "WorkerCommand.cancelFloor": "alignment.auto",
  "WorkerCommand.cancelSelection": "selection.manual",
  "WorkerCommand.cancelTransform": "transform.manual",
  "WorkerCommand.clipSelection": "selection.advanced",
  "WorkerCommand.color": "color.basic",
  "WorkerCommand.colorPick": "selection.color",
  "WorkerCommand.colorTolerance": "selection.color",
  "WorkerCommand.commitTransaction": "internal.lifecycle",
  "WorkerCommand.confirmFilter": "selection.volume",
  "WorkerCommand.confirmSelection": "selection.manual",
  "WorkerCommand.crop": "cleanup.edit",
  "WorkerCommand.delete": "cleanup.edit",
  "WorkerCommand.detectFloor": "alignment.auto",
  "WorkerCommand.duplicate": "processing.advanced",
  "WorkerCommand.endColor": "color.basic",
  "WorkerCommand.endOpacity": "color.advanced",
  "WorkerCommand.endTolerance": "selection.color",
  "WorkerCommand.endTransform": "transform.manual",
  "WorkerCommand.export": "save.copy",
  "WorkerCommand.fillPick": "selection.color",
  "WorkerCommand.fillTolerance": "selection.color",
  "WorkerCommand.grade": "color.basic",
  "WorkerCommand.invert": "selection.manual",
  "WorkerCommand.morphology": "selection.advanced",
  "WorkerCommand.morphologyRange": "selection.advanced",
  "WorkerCommand.operationBind": "internal.lifecycle",
  "WorkerCommand.operationRetire": "internal.lifecycle",
  "WorkerCommand.operationStatus": "internal.lifecycle",
  "WorkerCommand.planeNormal": "alignment.manual",
  "WorkerCommand.point": "alignment.manual",
  "WorkerCommand.polygon": "selection.manual",
  "WorkerCommand.previewFilter": "selection.volume",
  "WorkerCommand.rebaseTransform": "transform.manual",
  "WorkerCommand.rectangle": "selection.manual",
  "WorkerCommand.redo": "history.edit",
  "WorkerCommand.redoTransform": "transform.manual",
  "WorkerCommand.resetAlignment": "alignment.manual",
  "WorkerCommand.resetCleanup": "cleanup.edit",
  "WorkerCommand.resetOpacity": "color.advanced",
  "WorkerCommand.resetTransform": "transform.manual",
  "WorkerCommand.restore": "cleanup.edit",
  "WorkerCommand.rollbackTransaction": "internal.lifecycle",
  "WorkerCommand.selectAll": "selection.manual",
  "WorkerCommand.selectNone": "selection.manual",
  "WorkerCommand.selectionMapBegin": "internal.lifecycle",
  "WorkerCommand.selectionMapCommit": "internal.lifecycle",
  "WorkerCommand.selectionMapRelease": "internal.lifecycle",
  "WorkerCommand.single": "selection.manual",
  "WorkerCommand.summary": "internal.lifecycle",
  "WorkerCommand.transform": "transform.manual",
  "WorkerCommand.transformFocus": "transform.manual",
  "WorkerCommand.undo": "history.edit",
  "WorkerCommand.undoTransform": "transform.manual",
  "WorkerCommand.volume": "selection.manual"
};
export function registeredAllowed(binding: string, surface = 'ui', capabilities: readonly string[] = []): boolean {
  return productAllowed(productBindings[binding] ?? '', 'web', 'web-lite', surface, 'editor', capabilities);
}
